import * as api from '../api';

export const getAllExerciseTags = async () =>
    await api.get('/2.0/coach/tags/getByType/3');

export const getAllTrainingEffectTags = async () =>
    await api.get('/2.0/coach/tags/getByType/4');

export const getAllTags = async fetchAthCount => {
    let params = '';
    if (fetchAthCount) params = '?fetchAthleteCount=1';
    return await api.get(`/2.0/coach/tags/getSportsTags${params}`);
};

export const getTagsForAthlete = async userId =>
    await api.get(`/2.0/coach/tags/getAthleteTags/${userId}`);

export const getPercentageTagged = async groupId => {
    if (groupId)
        return await api.get(`/2.0/coach/tag/percentageTagged/${groupId}`);
    return await api.get('/2.0/coach/tag/percentageTagged');
};

export const deleteTagRelationship = async (userId, tagId) =>
    await api.del(`/2.0/coach/tags/${userId}/${tagId}`);

export const saveTagRelationship = async (userId, tagId) =>
    await api.post(`/2.0/coach/tags/${userId}/${tagId}`);

export const updateUserTags = async (userId, tags) =>
    await api.post(`/2.0/coach/tags/${userId}`, tags);

export const updateBulkTags = async data =>
    await api.post('/2.0/coach/bulk/tags', data);

export const createTag = async tag =>
    await api.post('/2.0/coach/tags/createExerciseTag', tag);

export const createTrainingEffectTag = async tag => {
    const type = 4;
    return await api.post(`/2.0/coach/tags/createTag/${type}`, tag);
};



// WEBPACK FOOTER //
// ./src/api/service/tagService.js